module.exports = __webpack_public_path__ + "img/utilitylight_driving.1ee06f24.svg";